import styled from "styled-components";

export const StyledLandingPageWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100vh;
  background-image: url("/assets/login-page-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
`;

export const LeftContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
`;

export const TopDescription = styled.div`
  position: absolute;
  text-align: center;
  color: #006f35;
  font: normal normal normal 24px/22px Open Sans;
  letter-spacing: 0.98px;
  width: 348px;
  margin-top: 39px;
`;

export const LeftBottomText = styled.div`
  position: absolute;
  text-align: center;
  margin: auto;
  height: fit-content;
  bottom: 60px;
`;

export const RightContainer = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const LogoContainer = styled.div`
  margin-top: 7vh;
  right: 400px;
  height: 90px;
`;

export const WelcomeText = styled.div`
  text-align: center;
  font: normal normal 600 24px/33px Open Sans;
  letter-spacing: 0px;
  color: #383c38;
  opacity: 1;
  margin-top: 7vh;
`;

export const DescriptionWrapper = styled.div`
  margin: auto;
  margin-top: 5vh;
  width: 585px;
  margin-bottom: 20px;
`;

export const Copyright = styled.div`
  width: 100%;
  font: normal normal normal 18px/22px Open Sans;
  letter-spacing: 0.74px;
  color: #000000;
  opacity: 0.57;
  text-align: center;
  margin-bottom: 20px;
`;

export const SignInBtnWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  margin: auto;
  background-color: black;
  margin-top: 20vh;
`;

export const LoaderWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  margin: auto;
  margin-top: 20vh;
`;

export const SignInBtn = styled.div`
  display: flex;
  padding: 8px;
  background-color: #ffffff;
  font: normal normal normal 16px Open Sans;
  letter-spacing: 0.74px;
  color: #000000;
  opacity: 1;
  width: 245px;
  height: 30px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const MsOfficeLogo = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: red;
`;

export const LeftBottomMainText = styled.div`
  color: #FFFFFF;
  font: normal normal bold 43px/59px Open Sans;
  letter-spacing: 0.74px;
  padding-top: -10px;
`;

export const LeftBottomSubText = styled.div`
  color: #FFFFFF;
  font: normal normal bold 22px/16px Open Sans;
  letter-spacing: 0.74px;
  padding-top: 10px;
`;